import React, { useState, Fragment } from "react";
import { newGlobalFileServer } from "../../../../axiosInstance";
import PopUp from "../../containers/PopUp";
import ProductPage from "./ProductPopUp";
import { X } from "lucide-react";

const ProductPageWithImg = ({ close, selectedProd }) => {
  const [imageModal, setImageModal] = useState(false);

  return (
    <Fragment>
      <PopUp wrapperClassName="popup-wrapper--product" close={close}>
        <ProductPage
          selectedProd={selectedProd}
          setImageModal={(data) => setImageModal(data)}
        />
        <div onClick={close} className="overflow"></div>
      </PopUp>
      {imageModal ? (
        <div className="img-popup">
          <button
            type="button"
            className="close close-popup"
            onClick={() => setImageModal(false)}
            aria-label="סגור"
          >
            <X className="close-popup__icon" size={22} strokeWidth={2} />
          </button>
          <img
            loading="lazy"
            className="product-img"
            src={newGlobalFileServer + imageModal}
            alt={selectedProd.ProductName}
          />
        </div>
      ) : null}
    </Fragment>
  );
};

export default ProductPageWithImg;
